import { forwardRef, useRef, useImperativeHandle, useState, useEffect } from 'react';
import Image from 'next/image';

//* Context
import withUIContext from '@/context/consumerHOC/UIConsumer';

//* Styles
import ImageStyle from './style';

const CustomImage = forwardRef(({ src, alt, className, width, height, priority = false, double, winWidth, onLoad, isOpacityZero = false, onClick }, ref) => {
	//! Ref
	const imgRef = useRef();

	//! State
	const [loaded, setLoaded] = useState(false);

	//! Mobile Desktop
	const doubleSrc = double ? (winWidth >= 1280 ? double?.[0]?.src : double?.[1]?.src) : null;
	const doubleAlt = double ? (winWidth >= 1280 ? double?.[0]?.alt : double?.[1]?.alt) : null;

	useImperativeHandle(ref, () => imgRef.current, []);

	//! Handle Image Load
	const onLoadCallback = () => {
		setLoaded(true);
	};

	//! Check
	const image = typeof src === 'string' ? src.replace('//images', 'https://images') : src;

	useEffect(() => {
		typeof onLoad === 'function' && onLoad(loaded);
	}, [loaded]);

	return (
		<ImageStyle
			ref={imgRef}
			onClick={onClick}
			className={`imageCont ${className || ''}`}
			style={{ width, height, backgroundColor: loaded ? (isOpacityZero ? '#ECEDEE' : 'transparent') : '#ECEDEE' }}>
			<div className='image'>
				<Image
					fill
					draggable={false}
					placeholder='blur'
					priority={priority}
					onLoad={onLoadCallback}
					quality={90}
					sizes='(max-width: 767px) 100%'
					alt={alt || doubleAlt || 'image'}
					loading={priority ? 'eager' : 'lazy'}
					style={{ opacity: loaded ? (isOpacityZero ? 0 : 1) : 0 }}
					src={(typeof image === 'object' ? image.src : image) || doubleSrc || '/images/default.jpeg'}
					blurDataURL={(typeof image === 'object' ? image.blurDataURL : image) || doubleSrc || '/images/default.jpeg'}
				/>
			</div>
		</ImageStyle>
	);
});

CustomImage.displayName = 'CustomImage';

export default withUIContext(CustomImage, ['winWidth']);
